module.exports = __webpack_public_path__ + "img/cp47-r1.e08e3e67.jpg";